<template>
  <standalone-layout top-classes="mt-5">
    <template v-slot:heading>Neues Passwort setzen</template>
    <template v-slot:main>
      <NewPassword :token="$route.query.t"/>
    </template>
  </standalone-layout>
</template>

<script>
import StandaloneLayout from "@/layouts/StandaloneLayout";
import NewPassword from "@/components/auth/NewPassword";
export default {
  components: {NewPassword, StandaloneLayout}
}
</script>